export default "__VITE_ASSET__CrHt25AZ__"